module.exports = __webpack_public_path__ + "images/花筑院子全景_08-4.jpg?v=b4fdfc6c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_08-4.jpg
 ** module id = 84
 ** module chunks = 1 2
 **/